import { CrudService } from './CrudService';
import { resources } from '../resources';
import { LanguageDto } from '../models/settings/LanguageDto';
import { BaseSearchParams } from '../params/BaseSearchParams';

export class CodeListService extends CrudService<LanguageDto, BaseSearchParams> {
  constructor() {
    super({
      query: resources.queryLanguages,
      create: resources.createLanguage,
      update: resources.updateLanguage,
      delete: resources.deleteLanguage,
      idKey: 'code',
    });
  }
}
